module.exports = __webpack_public_path__ + "img/pc.6bfac12d.png";